import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'app/authentication/service';
import { ApiRouteConstants } from 'app/shared/constants/api.constants';

export const STAFF_TOKEN_HEADER = 'x-staff-token';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private _authenticationService: AuthenticationService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentUser = this._authenticationService.currentUserValue;
    const partnerToken = currentUser?.partnerToken || currentUser?.accessToken;
    const isLoggedIn = currentUser && partnerToken;
    const isApiUrl = request.url.startsWith(ApiRouteConstants.API_BASE_PATH);
    if (isLoggedIn && isApiUrl) {
      const headers: Record<string, string> = {
        Authorization: `Bearer ${partnerToken}`,
      };
      if (currentUser.staffToken) {
        headers[STAFF_TOKEN_HEADER] = currentUser.staffToken;
      }
      request = request.clone({ setHeaders: headers });
    }
    return next.handle(request);
  }
}
